var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"navigation",style:(_vm.configStyles.primary.text)},[_c('router-link',{attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.config.BRIEF_NEXT)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }